export const formatOfferingAmountOption = offeringAmount => {
  if (typeof offeringAmount?.predefinedValues === 'string') {
    try {
      // eslint-disable-next-line no-param-reassign
      offeringAmount.predefinedValues = JSON.parse(offeringAmount.predefinedValues);
    } catch (e) {
      return offeringAmount;
    }
  }

  return offeringAmount;
};
